import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { getTabMarginStyles } from '@aibees/shared/theme/overrides/components/tabs';
import { keyframes } from '@mui/material';

export const root: SxStyle = {
  paddingLeft: (p) => p.spacing(1),
};

const rotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
export const spinningIcon: SxStyle = {
  animation: `${rotateAnimation} 1s linear infinite`,
};

export const disabledButtonWrapper: SxStyleFunc<{ fullWidth?: boolean }> = ({
  fullWidth,
}) => ({
  marginRight: (p) => getTabMarginStyles(p, fullWidth),
});
